/* eslint-disable import/newline-after-import, import/first */

//region 1. Platform Libraries
import bodyParser from 'body-parser';
import express from 'express';
const ipaddr = require('ipaddr.js');
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkPort from '../middleware/checkPort';
import checkPublicIP from '../middleware/checkPublicIP';
import checkRecorderModule from '../middleware/checkRecorderModule';
//endregion

const context = {
    router: express.Router(),
    recorders: null,
    logger: null,
};

context.router.post('/', bodyParser.json());
context.router.post('/', checkPublicIP);
context.router.post('/', checkPort);
context.router.post('/', checkRecorderModule);
context.router.post('/', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'POST /recorders' });
    log('debug', JSON.stringify(req.body, null, 2));
    const now = new Date();
    const recorder = {
        public_ip: req.body.publicIp,
        private_ip: ipaddr.process(req.ip).toString(),
        port: req.body.port,
        module: req.body.module,
        service: req.body.service,
        created: now,
        updated: now,
    };
    context.recorders.insertOne(recorder, (insertOneErr, insertOneRes) => {
        if (insertOneErr) {
            log('error', insertOneErr.message);
            res.status(500).send(insertOneErr.message);
            return;
        }
        log('info', `Recorder ${insertOneRes.insertedId} Created`);
        res.type('text/plain');
        res.status(201).send(new Buffer(`${insertOneRes.insertedId}`));
    });
});

context.router.put('/:id', bodyParser.json());
context.router.put('/:id', checkObjectID);
context.router.put('/:id', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
    log('debug', JSON.stringify(req.body, null, 2));
    [
        'cpuUsagePercentage',
        'memoryUsagePercentage',
        'hddUsageKB',
        'hddTotalKB',
        'netUploadBytesPerSecond',
        'netDownloadBytesPerSecond',
    ].forEach((property) => {
        if ({}.hasOwnProperty.call(req.body, property)) {
            return;
        }
        const message = `Heartbeat Body Contains No ${property}`;
        log('error', message);
        res.status(400).send(message);
        throw new Error(message);
    });
    const diff = {
        updated: new Date(),
        stream_infos: [],
    };
    if (req.body.streamInfos) {
        req.body.streamInfos.forEach((streamInfo) => {
            diff.stream_infos.push({
                id: streamInfo.id,
                archive: streamInfo.archiveStarted,
                live: streamInfo.liveStarted,
                event: streamInfo.eventStarted,
            });
        });
    }
    diff.cpu_load = Math.ceil(req.body.cpuUsagePercentage * 100);
    diff.mem_load = Math.ceil(req.body.memoryUsagePercentage);
    diff.hdd_load = Math.ceil((req.body.hddUsageKB * 100) / req.body.hddTotalKB);
    diff.upload_kbps = Math.ceil((req.body.netUploadBytesPerSecond * 8) / 1024);
    diff.download_kbps = Math.ceil((req.body.netDownloadBytesPerSecond * 8) / 1024);
    const _id = new MongoClient.ObjectID(req.params.id);
    context.recorders.updateOne({ _id }, { $set: diff }, (updateOneErr, updateOneRes) => {
        if (updateOneErr) {
            log('error', updateOneErr.message);
            res.status(500).send(updateOneErr.message);
            return;
        }
        if (!updateOneRes.matchedCount) {
            const message = 'Recorder Not Found';
            log('error', message);
            res.status(500).send(message);
            return;
        }
        log('info', '200 OK');
        res.sendStatus(200);
    });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /recorders
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountRecorders(options) {
    context.logger = options.logger;
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountRecorders' });
    log('debug', 'Mounting router for /recorders....');
    options.app.use('/recorders', context.router);
    context.recorders = options.database.collection('recorders');
    log('info', 'Router for /recorders Mounted');
}
